import { xMean } from 'ml-spectra-processing/x';
import { seriesFromArray } from "../series_from_array.js";
export function meanFilter(chromatogram, seriesName, options = {}) {
    const { factor = 2 } = options;
    const series = chromatogram.getSeries2D(seriesName);
    const filtered = [];
    const data = series.getData();
    for (const datum of data) {
        filtered.push(applyFilter(datum, factor));
    }
    return seriesFromArray(filtered);
}
function applyFilter(series, factor) {
    const filtered = [[], []];
    if (series[1].length === 0)
        return filtered;
    const meanIntensity = factor * xMean(series[1]);
    for (let i = 0; i < series[0].length; i++) {
        if (series[1][i] > meanIntensity) {
            filtered[0].push(series[0][i]);
            filtered[1].push(series[1][i]);
        }
    }
    return filtered;
}
//# sourceMappingURL=mean_filter.js.map